<template>
  <b-modal ref="login-modal" id="login-modal" size="sm" hide-footer centered>
    <template slot="modal-header">
      <h4 class="modal-title">Inloggen</h4>
      <button type="button" aria-label="Close" @click="hideModal" class="close">
        <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
      </button>
    </template>
    <template slot="default">
      <div class="col-md-13">
        <div v-if="loginFailed" class="form-group alert alert-danger" role="alert">
          <strong>E-mail & wachtwoord combinatie incorrect.</strong>
        </div>

        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label for="login-email">E-Mailadres</label>
            <input
              id="login-email"
              type="email"
              class="form-control"
              :class="{'is-invalid': $v.email.$error}"
              v-model="email"
              @blur="$v.email.$touch()"
              autocomplete="email"
              autofocus
            >
            <span v-if="$v.email.$error" class="invalid-feedback" role="alert">
              <strong>Vul a.u.b. uw e-mailadres in.</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="login-password">Wachtwoord</label>
            <input
              id="login-password"
              type="password"
              class="form-control"
              :class="{'is-invalid': $v.password.$error}"
              v-model="password"
              @blur="$v.password.$touch()"
              autocomplete="current-password"
            >
            <span v-if="$v.password.$error" class="invalid-feedback" role="alert">
              <strong>Vul a.u.b. uw wachtwoord in.</strong>
            </span>
            <span class="comment underline cursor-pointer float-right" @click="forgotPassword">
              Wachtwoord vergeten?
            </span>
          </div>

          <div class="row justify-content-center mt-5">
            <div class="col-md-13">
              <button
                type="submit"
                class="btn btn-oldevuuren w-100 btn-round"
                :disabled="$v.$invalid"
                :class="{'disabled cursor-not-allowed': $v.$invalid}"
              >
                Inloggen
                <font-awesome-icon class="font-awesome-icon" v-if="loginBusy" icon="spinner" spin/>
              </button>
            </div>
          </div>
          <div class="row align-content-center text-center mt-2">
            <div class="col-md-13">
              <span class="comment">Geen account?</span>&nbsp;<span @click="register" class="link underline">Meld je aan</span>
            </div>
          </div>
        </form>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { email, required } from 'vuelidate/lib/validators'
  import { LOGIN, MUTATE_LOGIN_FAILED } from '../../store/types'

  export default {
    props: ['forgotPasswordParent', 'registerParent'],
    data() {
      return {
        email: '',
        password: ''
      }
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    },
    computed: {
      loginBusy() {
        return !this.$store.getters.loginBusy ? false : this.$store.getters.loginBusy
      },
      loginFailed() {
        return !this.$store.getters.loginFailed ? false : this.$store.getters.loginFailed
      }
    },
    methods: {
      forgotPassword() {
        this.$refs['login-modal'].hide()
        this.forgotPasswordParent()
      },
      register() {
        this.$refs['login-modal'].hide()
        this.registerParent()
      },
      showModal() {
        this.$refs['login-modal'].show()
      },
      hideModal() {
        this.$refs['login-modal'].hide()
      },
      onSubmit() {
        // Reset loginFailed
        this.$store.commit(MUTATE_LOGIN_FAILED, false)

        const formData = {
          email: this.email,
          password: this.password
        }

        this.$store.dispatch(LOGIN, {
          email: formData.email,
          password: formData.password
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
